window.helpers = {};

window.helpers.equalHeight = function (items, cutoff) {

    function setHeight(items, cutoff) {
        $(window).imagesLoaded(function () {
            cutoff = typeof cutoff !== 'undefined' ? cutoff : false;
            var heightToSet = 0;

            items.css('height', '');

            if(!cutoff) {
                items.each(function () {
                    if($(this).outerHeight() > heightToSet) {
                        heightToSet = $(this).outerHeight();
                    }
                });

                items.css('height', heightToSet);
            } else {
                if($(window).width() > cutoff) {
                    items.each(function () {
                        if($(this).outerHeight() > heightToSet) {
                            heightToSet = $(this).outerHeight();
                        }
                    });

                    items.css('height', heightToSet);
                } else {
                    items.css('height', '');
                }
            }
        });
    }

    setHeight(items, cutoff);
    $(window).on('resize', function () { setHeight(items, cutoff); });

}

require('../vendor/bootstrap.min');
require('../vendor/imagesloaded.pkgd.min.js');
require('../vendor/jquery.validate.min');
require('../vendor/picturefill');
require('../vendor/slick.min');
require('jquery-parallax.js');

require('./general');

require('./case-study-detail');
// require('./idx-archive');

require('../blocks/construction-projects');
require('../blocks/hero-carousel');
require('../blocks/testimonials');
require('../blocks/case-study-carousel');
require('../blocks/contact-form-intro');
require('../blocks/development-projects');
require('../blocks/upcoming-projects');
require('../blocks/timeline');
require('../blocks/drag-compare');
require('../blocks/brand-highlight');
require('../blocks/team-tab');
require('../blocks/news-carousel');
require('./ga-events');

APP = {

    global: {

        init: function() {

            // this.initLocalTestingImages();

            this.initBootstrapDefaults();
            this.initNavControl();
            this.initMobileNavControl();
            this.initSearchControl();
            this.initHomepage();
            this.initTeamMemberSlideshow();
            this.initContainerSetPadding();
            this.initTeamMemberPage();
            this.initHeroOffsetting();
            this.initProjectGallery();
            this.initSpacingDetailsSizing();

            if($('section#contact-maps-and-details').length) {
                this.initContactMaps();
            }

            if($('section#commercial-real-estate').length) {
                this.initCommercialRealEstateControls();
            }

            if($('.commercial-listing-single').length) {
                this.initCommercialRealEstateListingMap();
                this.initCommercialRealEstateListingSlideshow();
                this.initCommercialRealEstateListingForm();
            }

            if($('#residential-testimonials').length) { this.initResidentialTestimonialSlider(); }

            if($('#contact').length) { this.initContactPageControls(); }

            if($('#page').length || $('#article').length || $('#case-study-single').length) {
                this.initGeneralPage();
            }

            if($('#news').length || $('#article').length) { this.initBlogControls(); }

            if($('#careers').length) { this.initCareersControls(); }

            if($('#hospitality-landing').length) { this.initHospitalityControls(); }

            if($('#case-study-landing').length) { this.initCaseStudyLandingControls(); }
            if($('#case-study-single').length) { this.initCaseStudySingleControls(); }

            if($('#testimonial').length) { this.initFooterTestimonialsSlider(); }

        },

        initLocalTestingImages: () => {

            console.log('Local Testing Images');

            // loop through all images and rewrite if the image src contains /uploads/ and is prior to feb 1 2023
            $('img').each(function() {
                var src = $(this).attr('src');
                if(src.indexOf('/uploads/') > -1) {
                    if(src.indexOf('2023/02') > -1 || src.indexOf('2023/01') > -1) {
                        // do nothing as this should live locally
                    } else {
                        $(this).attr('src', src.replace('lloyd-companies.test', 'lloydcompanies.com'));
                    }
                }
            });

            $('source').each(function() {
                var src = $(this).attr('srcset');
                if(src.indexOf('/uploads/') > -1) {
                    if(src.indexOf('2023/02') > -1) {
                        // do nothing as this should live locally
                    } else {
                        $(this).attr('srcset', src.replace('lloyd-companies.test', 'lloydcompanies.com'));
                    }
                }
            });

            $('*').filter(function() {
                if (this.currentStyle)
                    return this.currentStyle['backgroundImage'] !== 'none';
                else if (window.getComputedStyle)
                    return document.defaultView.getComputedStyle(this,null)
                        .getPropertyValue('background-image') !== 'none';
            }).each(function(i, e) {
                var src = $(e).css('background-image');
                if(src.indexOf('/uploads/') > -1) {
                    if(src.indexOf('2023/02') > -1) {
                        // do nothing as this should live locally
                    } else {
                        $(e).css('background-image', src.replace('lloyd-companies.test', 'lloydcompanies.com'));
                    }
                }
            });

        },

        initSpacingDetailsSizing: function () {
            if($(".spacing-details").length) {

                $('.spacing-details').each(function () {
                    var subItems = $(this).find('.spacing-details-item'),
                        heightToSet = 0;

                    subItems.css('height', '');
                    subItems.each(function () {
                        if($(this).outerHeight() > heightToSet) {
                            heightToSet = $(this).outerHeight();
                        }
                    });
                    subItems.css('height', heightToSet);
                });

            }
        },

        initBootstrapDefaults: function () {
            $('[data-toggle="dropdown"]').dropdown();
        },

        initNavControl: function () {

            function sizeNavContainers() {
                $('.nav-complex-dropdown').each(function () {
                    var subItems = $(this).find('.nav-complex-subpage-item-top-row'),
                        heightToSet = 0;

                    subItems.css('height', '');
                    subItems.each(function () {
                        if($(this).outerHeight() > heightToSet) {
                            heightToSet = $(this).outerHeight();
                        }
                    });
                    subItems.css('height', heightToSet);
                });
            }
            // $(window).on('resize', function () { sizeNavContainers(); });

            // Close when clicking outside of any menus
            $('body').on('click', function () { closeAllMenusExceptThis(); });
            $('li.main-nav-item').on('click', function (e) { e.stopPropagation(); });
            $('.standard-dropdown-menu').on('click', function (e) { e.stopPropagation(); });
            $('.nav-complex-dropdown').on('click', function (e) { e.stopPropagation(); });

            $('.standard-dropdown-toggle').on('click', function () {
                var parent = $(this).parent('li'),
                    dropdownMenu = parent.find('.standard-dropdown-menu');

                closeAllMenusExceptThis(dropdownMenu, parent);

                if(parent.hasClass('is-active')) {
                    parent.removeClass('is-active');
                    dropdownMenu.slideUp(300);
                } else {
                    parent.addClass('is-active');
                    dropdownMenu.slideDown(300);
                }
            });

            $('.complex_dropdown').on('click', function () {
                var target = $(this).data('target');

                closeAllMenusExceptThis($(target), $(this));

                if($(target).hasClass('is-open')) {
                    $(target).removeClass('is-open');
                    $(this).removeClass('is-active');
                    $(target).addClass('is-hiding');
                    setTimeout(function () {
                        $(target).addClass('is-hidden');
                    }, 400);
                } else {
                    $(target).addClass('is-open');
                    $(this).addClass('is-active');
                    $(target).removeClass('is-hidden');
                    setTimeout(function () {
                        $(target).removeClass('is-hiding');
                        sizeNavContainers();
                    }, 100);
                }
            });

            function closeAllMenusExceptThis(excludeMenu, excludeNavItem) {
                var complexDropdowns = '',
                    standardDropdowns = '',
                    listItemsToClear = '';

                if(excludeNavItem === undefined || excludeNavItem === false) {
                    listItemsToClear = $('li.main-nav-item');
                } else {
                    listItemsToClear = $('li.main-nav-item').not(excludeNavItem);
                }

                listItemsToClear.removeClass('is-active');

                if(excludeMenu === undefined || excludeMenu === false) {
                    complexDropdowns = $('.nav-complex-dropdown');
                    standardDropdowns = $('.standard-dropdown-menu');
                } else {
                    complexDropdowns = $('.nav-complex-dropdown').not(excludeMenu);
                    standardDropdowns = $('.standard-dropdown-menu').not(excludeMenu);
                }

                complexDropdowns.each(function () {
                    if($(this).hasClass('is-open')) {
                        $(this).removeClass('is-open');
                        $(this).addClass('is-hiding');
                        var that = $(this);
                        setTimeout(function () {
                            that.addClass('is-hidden');
                        }, 400);
                    }
                });

                standardDropdowns.each(function () {
                    $(this).slideUp(300);
                });
            }
        },

        initMobileNavControl: function () {

            var desktopUtilityNav = $('.desktop-utility-menu'),
                desktopUtilityNavToggle = $('.desktop-menu-open-button');

            // desktopUtilityNavToggle.on('click', function (e) {
            //     e.stopPropagation();
            //     desktopUtilityNav.slideToggle();
            // });

            // desktopUtilityNav.on('click', function (e) { e.stopPropagation(); });

            // $(window).on('click', function () {
            //     desktopUtilityNav.slideUp();
            // });

            var mobileNav = $('#mobile-navigation'),
                mobileNavSiteOverlay = $('#mobile-navigation-site-overlay');

            $('.mobile-menu-open-button').on('click', function () {
                mobileNav.addClass('is-opened');
                mobileNavSiteOverlay.removeClass('is-hidden');
                setTimeout(function () { mobileNavSiteOverlay.removeClass('is-hiding'); }, 100);
                $('body').addClass('mobile-menu-open');
                $('.header-top-row').addClass('mobile-menu-open');
            });

            $('.mobile-menu-close-button').on('click', function () {
                mobileNav.removeClass('is-opened');
                mobileNavSiteOverlay.addClass('is-hiding');
                setTimeout(function () { mobileNavSiteOverlay.addClass('is-hidden'); }, 400);
                $('body').removeClass('mobile-menu-open');
                $('.header-top-row').removeClass('mobile-menu-open');
            });

            mobileNavSiteOverlay.on('click', function () {
                mobileNav.removeClass('is-opened');
                mobileNavSiteOverlay.addClass('is-hiding');
                setTimeout(function () { mobileNavSiteOverlay.addClass('is-hidden'); }, 400);
                $('body').removeClass('mobile-menu-open');
                $('.header-top-row').removeClass('mobile-menu-open');
            });

            function setMobileMenuHeight() {
                $('.mobile-nav-contents').css('height', $(window).outerHeight() - 85);
                if($(window).width() < 992) {
                    $('.wrapper').css('width', $(window).width());
                } else {
                    $('.wrapper').css('width', '');
                }
            }
            setMobileMenuHeight();
            $(window).on('resize', function () { setMobileMenuHeight(); });

            $('.mobile-standard-dropdown-toggle').on('click', function () {
                var parent = $(this).parent('li'),
                    menu = parent.find('.mobile-standard-dropdown-menu');

                if(parent.hasClass('is-open')) {
                    parent.removeClass('is-open');
                    menu.slideUp();
                } else {
                    parent.addClass('is-open');
                    menu.slideDown();
                }
            });
        },

        initSearchControl: function () {
            var searchContainer = $('.search-container'),
                searchContainerMobile = $('#search-container-mobile');

            searchContainer.on('click', function (e) { e.stopPropagation(); });
            searchContainerMobile.on('click', function (e) { e.stopPropagation(); });
            $('#site-header').on('click', function (e)  { e.stopPropagation(); })

            $('body').on('click', function () {
                searchContainer.removeClass('is-opened');
                searchContainerMobile.slideUp();
            });

            $('.search-open-icon').on('click', function () { searchContainer.addClass('is-opened'); });
            $('.search-close-button').on('click', function () { searchContainer.removeClass('is-opened'); });

            // $('.mobile-search-open-button').on('click', function () { searchContainerMobile.slideToggle(); });
            // $('.search-close-button-mobile').on('click', function () { searchContainerMobile.slideUp(); });
        },

        initHomepage: function () {
            if($('#home #hero').length) {
                $('#home #hero').imagesLoaded(function () {
                    $('.parallax-mirror img').attr('alt', $('#alt-for-hero-parallax').val());

                    $('#home #hero .fade-in-overlay').css('opacity', 0);
                    setTimeout(function () { $('#home #hero .hero-overlay').addClass('showing'); }, 300);
                    setTimeout(function () { $('#home #hero .fade-in-overlay').remove(); }, 600);
                });
            }
        },

        initProjectGallery: function () {
            if($('#project-gallery').length) {
                var homeProjectGallery = $('#project-gallery .project-gallery-inner-container').slick({
                    infinite: false,
                    slidesToShow: 2,
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ],
                    prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/controls/prev-slide-arrow.svg" alt="Previous Project"></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/controls/next-slide-arrow.svg" alt="Next Project"></button>'
                });

                homeProjectGallery.on('afterChange', function(slick, currentSlide) {
                    if(currentSlide.currentSlide === 0) {
                        $('#project-gallery-slick-prev-mobile').addClass('slick-disabled');
                        $('#project-gallery-slick-next-mobile').removeClass('slick-disabled');
                    } else if(currentSlide.currentSlide === (currentSlide.slideCount - 1)) {
                        $('#project-gallery-slick-prev-mobile').removeClass('slick-disabled');
                        $('#project-gallery-slick-next-mobile').addClass('slick-disabled');
                    } else {
                        $('#project-gallery-slick-prev-mobile').removeClass('slick-disabled');
                        $('#project-gallery-slick-next-mobile').removeClass('slick-disabled');
                    }
                });

                $('#project-gallery-slick-prev-mobile').on('click', function () {
                    homeProjectGallery.slick('slickPrev');
                });

                $('#project-gallery-slick-next-mobile').on('click', function () {
                    homeProjectGallery.slick('slickNext');
                });
            }
        },

        initTeamMemberSlideshow: function () {
            if($('.team-member-slideshow').length) {
                $('.team-member-slideshow').slick({
                    dots: true
                });
            }
        },

        initTeamMemberPage: function () {
            // equalHeight($('main#team-member .lower-section-item'), 500);

            var heightToSet = 0;
            var items = $('main#team-member .lower-section-item');
            for(var i = 0; i < items.length; i+=2) {
                heightToSet = 0;
                var subItems = items.slice(i, i+2);
                subItems.css('height', '');
                if($(window).width() > 500) {
                    $(subItems).each(function () {
                        if($(this).outerHeight() > heightToSet) {
                            heightToSet = $(this).outerHeight();
                        }
                    });
                    $(subItems).css('height', heightToSet);
                }
            }

            $('#filter-toggle-mobile').on('click', function () {
                $('#filter-dropdown-mobile').slideToggle();
            });
        },

        initContainerSetPadding: function () {
            function containerSetPadding() {
                var containerWidth = $('.container .row').width(),
                    windowWidth = $('.wrapper').width(),
                    padding = (windowWidth - containerWidth) / 2;

                $('.container-set-left-padding').each(function () { $(this).css('padding-left', padding); });
                $('.container-set-right-padding').each(function () { $(this).css('padding-right', padding); });
            }
            containerSetPadding();
            $(window).on('resize', function () { containerSetPadding(); });
        },

        initHeroOffsetting: function () {
            function setHeroOffset() {
                var items = $('.main-hero-image'),
                    containerWidth = $('.container .row').width(),
                    windowWidth = $('.wrapper').width(),
                    offset= (windowWidth - containerWidth) / 2;

                if($(window).width() > 1500) {
                    items.each(function () {
                        if($(this).hasClass('no-offset ')) return;

                        if($(this).hasClass('pushed-left')) {
                            $(this).css('margin-left', 0 - offset);
                            $(this).css('margin-right', '');
                        } else if($(this).hasClass('pushed-right')) {
                            $(this).css('margin-right', 0 - offset);
                            $(this).css('margin-left', '');
                        }
                    });
                } else {
                    items.each(function () {
                        if($(this).hasClass('no-offset')) return;
                        $(this).css('margin-left', 0 - offset);
                        $(this).css('margin-right', 0 - offset);
                    });
                }
            }

            setHeroOffset();
            $(window).on('resize', function () { setHeroOffset(); });
        },

        initCommercialRealEstateControls: function () {

            // IE Input Fix
            if(browser() === "IE") {
                $('#minSquareFootage').addClass('ie-fix');
                $('#maxSquareFootage').addClass('ie-fix');
            }

            var searchData = window.commercialListingSearchData,
                searchInputForm = $('#search-input-form'),
                searchInputContainer = $('#search-listings-input-container'),
                searchInput = $('#commercial-listings-search-input'),
                searchInputPlaceholder = $('#commercial-listings-search-placeholder'),
                searchInputTrigger = $('#search-input-trigger'),
                listingsContainerEmpty = $('#listings-container-empty'),
                clearSearchButton = $('.clear-search-button'),
                searchInputFormGrid = $('#search-input-form-grid'),
                searchInputContainerGrid = $('#search-listings-input-container-grid'),
                searchInputGrid = $('#commercial-listings-search-input-grid'),
                searchInputPlaceholderGrid = $('#commercial-listings-search-placeholder-grid'),
                searchInputTriggerGrid = $('#search-input-trigger-grid'),
                listingsContainerEmptyGrid = $('#listings-container-empty-grid'),
                searchListingsMobileMenuToggle = $('#search-listings-mobile-menu-toggle'),
                searchListingsMobileMenu = $('#commercial-listings-interface .interface-toolbar');

            $('.property-type-dropdown-container .dropdown-menu li').on('click', function (e) { e.stopPropagation(); });
            $('.listing-agent-dropdown-container .dropdown-menu li').on('click', function (e) { e.stopPropagation(); });

            searchListingsMobileMenuToggle.on('click', function () {
                if($(this).hasClass('is-open')) {
                    $(this).removeClass('is-open');
                    searchListingsMobileMenu.slideUp();
                } else {
                    $(this).addClass('is-open');
                    searchListingsMobileMenu.slideDown();
                }
            });


            $('input[name=property-type]').on('change', function () {
                commercialListingsSearch();
            });

            $('input[name=listing-broker]').on('change', function () {
                commercialListingsSearch();
            });

            $('input[name=sale-type]').on('change', function () {
                commercialListingsSearch();
            });

            $('#minSquareFootage').on('change', function () {
                commercialListingsSearch();
            });

            $('#maxSquareFootage').on('change', function () {
                commercialListingsSearch();
            });

            // Search input

            function checkSearchInputField() {
                var search = searchInput.val();

                if(search.length) {
                    searchInputPlaceholderDisplay('hide');
                } else {
                    searchInputPlaceholderDisplay('show');
                }
            }

            checkSearchInputField();

            function searchInputPlaceholderDisplay(mode) {
                if(mode === "show") {
                    searchInputContainer.removeClass('is-active');
                    searchInputContainerGrid.removeClass('is-active');

                    searchInputPlaceholder.removeClass('hidden');
                    searchInputPlaceholderGrid.removeClass('hidden');

                    setTimeout(function () { searchInputPlaceholder.removeClass('hiding'); }, 100);
                    setTimeout(function () { searchInputPlaceholderGrid.removeClass('hiding'); }, 100);
                } else if(mode === "hide") {
                    searchInputContainer.addClass('is-active');
                    searchInputContainerGrid.addClass('is-active');

                    searchInputPlaceholder.addClass('hiding');
                    searchInputPlaceholderGrid.addClass('hiding');

                    setTimeout(function () { searchInputPlaceholder.addClass('hidden'); }, 350);
                    setTimeout(function () { searchInputPlaceholderGrid.addClass('hidden'); }, 350);
                }
            }

            searchInputPlaceholder.on('click', function () { searchInput.focus(); });
            searchInputPlaceholderGrid.on('click', function () { searchInputGrid.focus(); });

            searchInput.on('focusout', function () {
                checkSearchInputField();
                commercialListingsSearch();
            });

            searchInputGrid.on('focusout', function () {
                checkSearchInputField();
                commercialListingsSearch();
            });

            searchInput.on('focusin', function () { searchInputPlaceholderDisplay('hide'); });
            searchInputGrid.on('focusin', function () { searchInputPlaceholderDisplay('hide'); });

            // Keep both search inputs in sync
            searchInput.on('change', function () { searchInputGrid.val($(this).val()); });
            searchInputGrid.on('change', function () { searchInput.val($(this).val()); });

            searchInputTrigger.on('click', function () { searchInputForm.submit(); });
            searchInputTriggerGrid.on('click', function () { searchInputFormGrid.submit(); });

            searchInputForm.on('submit', function (e) {
                e.preventDefault();
                commercialListingsSearch();
            });

            searchInputFormGrid.on('submit', function (e) {
                e.preventDefault();
                commercialListingsSearch();
            });

            clearSearchButton.on('click', function () {
                $('input[name=property-type]').prop('checked', false);
                $('input[name=listing-broker]').prop('checked', false);
                $('input[name=sale-type]').prop('checked', false);
                $('#minSquareFootage').val('');
                $('#maxSquareFootage').val('');

                searchInput.blur();
                searchInputGrid.blur();

                searchInput.val('');
                searchInputGrid.val('');

                commercialListingsSearch();

                setTimeout(function () { checkSearchInputField(); }, 500);
            });

            // Main Search Function
            function commercialListingsSearch() {

                var propertyTypes = $('input[name=property-type]'),
                    propertyTypesSelected = [],
                    listingBrokers = $('input[name=listing-broker]'),
                    listingBrokersSelected = [],
                    saleTypes = $('input[name=sale-type]'),
                    saleTypesSelected = [],
                    minSquareFootage = $('#minSquareFootage').val(),
                    maxSquareFootage = $('#maxSquareFootage').val(),
                    listingCount = 0,
                    searchInputValue = searchInput.val();

                propertyTypes.each(function () {
                    if($(this).is(':checked')) { propertyTypesSelected.push($(this).val()); }
                });

                listingBrokers.each(function () {
                    if($(this).is(':checked')) { listingBrokersSelected.push(parseInt($(this).val())); }
                });

                saleTypes.each(function () {
                    if($(this).is(':checked')) { saleTypesSelected.push($(this).val()); }
                });

                var matchesPropertyType = false,
                    matchesBroker = false,
                    matchesSaleType = false,
                    overMinSize = false,
                    underMaxSize = false,
                    matchesSearchInput = false;

                for (var i = 0; i < searchData.length; i++) {

                    if(propertyTypesSelected.length) {
                        var propOptionsArray = searchData[i].property_type_options.split(',');

                        for (var pi = 0; pi < propOptionsArray.length; pi++) {
                            if(-1 !== $.inArray(propOptionsArray[pi], propertyTypesSelected)) {
                                matchesPropertyType = true;
                                break;
                            } else {
                                matchesPropertyType = false;
                            }
                        }
                    } else {
                        matchesPropertyType = true;
                    }

                    if(saleTypesSelected.length) {
                        var purchaseOptionsArray = searchData[i].purchase_type_options.split(',');

                        for (var pui = 0; pui < purchaseOptionsArray.length; pui++) {
                            if(-1 !== $.inArray(purchaseOptionsArray[pui], saleTypesSelected)) {
                                matchesSaleType = true;
                                break;
                            } else {
                                matchesSaleType = false;
                            }
                        }
                    } else {
                        matchesSaleType = true;
                    }

                    if(listingBrokersSelected.length) {

                        for (var iB = 0; iB < searchData[i].brokers.length; iB++) {
                            if (-1 !== $.inArray(searchData[i].brokers[iB], listingBrokersSelected)) {
                                matchesBroker = true; break;
                            } else {
                                matchesBroker = false;
                            }
                        }

                    } else {
                        matchesBroker = true;
                    }

                    if(searchData[i].sizing_type != null) {

                        switch (searchData[i].sizing_type) {
                            case "square-footage":

                                if(minSquareFootage !== "") {
                                    overMinSize = (parseInt(searchData[i].square_footage) >= parseInt(minSquareFootage));
                                } else {
                                    overMinSize = true;
                                }

                                if(maxSquareFootage !== "") {
                                    underMaxSize = (parseInt(searchData[i].square_footage) <= parseInt(maxSquareFootage));
                                } else {
                                    underMaxSize = true;
                                }

                                break;
                            case "square-footage-range":

                                if(minSquareFootage !== "") {
                                    overMinSize = (parseInt(searchData[i].max_square_footage) >= parseInt(minSquareFootage));
                                } else {
                                    overMinSize = true;
                                }

                                if(maxSquareFootage !== "") {
                                    underMaxSize = (parseInt(searchData[i].min_square_footage) <= parseInt(maxSquareFootage));
                                } else {
                                    underMaxSize = true;
                                }

                                break;
                            case "acres":
                                // TODO: Finish new sizing checks
                                break;
                            case "acres-range":
                                //
                                break;
                            default:
                                //
                                break;
                        }

                    } else {
                        underMaxSize = true;
                        overMinSize = true;
                    }

                    if(searchInputValue.length) {
                        var searchInputArray = searchInputValue.split(' ');

                        for (var s_i = 0; s_i < searchInputArray.length; s_i++) {
                            // Check Title
                            var title = searchData[i].title.toLowerCase();
                            if(-1 !== (title.search(searchInputArray[s_i].toLowerCase()))) {
                                matchesSearchInput = true; break;
                            } else {
                                matchesSearchInput = false;
                            }

                            // Check Brief
                            var brief = searchData[i].brief.toLowerCase();
                            if(-1 !== (brief.search(searchInputArray[s_i].toLowerCase()))) {
                                matchesSearchInput = true; break;
                            } else {
                                matchesSearchInput = false;
                            }

                            // Check Address
                            var address = searchData[i].address.toLowerCase();
                            if(-1 !== (address.search(searchInputArray[s_i].toLowerCase()))) {
                                matchesSearchInput = true; break;
                            } else {
                                matchesSearchInput = false;
                            }
                        }
                    } else {
                        matchesSearchInput = true;
                    }

                    if(
                        matchesPropertyType &&
                        matchesSaleType &&
                        matchesBroker &&
                        overMinSize &&
                        underMaxSize &&
                        matchesSearchInput
                    ) {
                        searchData[i].showing = true;
                        $('.cre-listing-' + searchData[i].id).removeClass('hidden');
                    } else {
                        searchData[i].showing = false;
                        $('.cre-listing-' + searchData[i].id).addClass('hidden');
                    }

                    // Check if a search is happening or not to display clear
                    if(
                        propertyTypesSelected.length === 0 &&
                        saleTypesSelected.length === 0 &&
                        listingBrokersSelected.length === 0 &&
                        minSquareFootage.length === 0 &&
                        maxSquareFootage.length === 0 &&
                        searchInputValue.length === 0
                    ) {
                        clearSearchButton.addClass('hiding');
                        setTimeout(function () { clearSearchButton.addClass('hidden'); }, 350);
                    } else {
                        clearSearchButton.removeClass('hidden');
                        setTimeout(function () { clearSearchButton.removeClass('hiding'); }, 100);
                    }
                }

                setCommercialListingsMap();

                equalHeight($('#commercial-real-estate .grid-view-container .grid-list-item-inner-container .border-container'));

                for (var i_l_c = 0; i_l_c < searchData.length; i_l_c++) {
                    if(searchData[i_l_c].showing) {
                        listingCount++;
                    }
                }

                $('#active-listings-count').html(listingCount);

                if(listingCount > 0) {
                    listingsContainerEmpty.addClass('hidden hiding');
                    listingsContainerEmptyGrid.addClass('hidden hiding');
                } else {
                    listingsContainerEmpty.removeClass('hidden');
                    listingsContainerEmptyGrid.removeClass('hidden');

                    setTimeout(function () {
                        listingsContainerEmpty.removeClass('hiding');
                        listingsContainerEmptyGrid.removeClass('hiding');
                    }, 100);
                }

            }


            var defaultMapOptions = {
                center: {lat: 43.545897, lng: -96.728025},
                zoom: 12,
                mapTypeControl: false,
                disableDefaultUI: false
            };

            function setCommercialListingsMap() {
                var map = new google.maps.Map(document.getElementById('commercial-real-estate-map-container'), defaultMapOptions),
                    infoWindow = new google.maps.InfoWindow();

                map.setOptions({styles: defaultGoogleMapStyles});

                for (var i = 0; i < searchData.length; i++) {

                    if(searchData[i].showing) {

                        var marker = new google.maps.Marker({
                            position: {
                                lat: parseFloat(searchData[i].latitude),
                                lng: parseFloat(searchData[i].longitude)
                            },
                            map: map,
                            title: searchData[i].title,
                            icon: '/assets/img/controls/icon-map-pin-green.svg'
                        });

                        var content = '' +
                        '<div class="info-popup-container">' +
                            '<a href="' + searchData[i].link + '" class="image-left">' +
                                '<img src="' + searchData[i].thumbnail_image + '" alt="">';

                                if(searchData[i].photo_count) {
                                    var photoCountLabel = (searchData[i].photo_count > 1) ? 'Photos' : 'Photo';
                                    content += '<div class="photo_count">' + searchData[i].photo_count + ' ' + photoCountLabel + '</div>';
                                }

                        content += '' +
                            '</a>' +
                            '<div class="details-right">' +
                                '<a class="title" href="' + searchData[i].link + '">' + searchData[i].title + '</a>' +
                                '<div class="address">' + searchData[i].address + '</div>' +
                                '<div class="spec-details">' +
                                    '<div class="spec-item">' + searchData[i].sizing_display + '</div>' +
                                    '<div class="spec-item">' + searchData[i].spacing_details_label + '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>';

                        google.maps.event.addListener(marker, 'click', (function(marker, content, infoWindow) {
                            return function() {
                                infoWindow.close();
                                infoWindow.setContent(content);
                                infoWindow.open(map, marker);
                            }
                        })(marker, content, infoWindow));

                    }

                }


                $('.map-zoom-trigger').off();
                $('.satellite-view-trigger').off();
                $('.roadmap-view-trigger').off();

                $('.map-zoom-trigger').on('click', function (event) {
                    $('#commercial-real-estate-map-container div.gm-style button[title="Toggle fullscreen view"]').trigger('click');
                });

                $('.satellite-view-trigger').on('click', function (event) {
                    map.setMapTypeId('satellite');
                    $(this).addClass('is-active');
                    $('.roadmap-view-trigger').removeClass('is-active');
                });

                $('.roadmap-view-trigger').on('click', function (event) {
                    map.setMapTypeId('roadmap');
                    $(this).addClass('is-active');
                    $('.satellite-view-trigger').removeClass('is-active');
                });
            }

            if($('#commercial-real-estate-map-container').length) {
                setCommercialListingsMap();
            }



            // Grid and List View Toggles
            $('.grid-view-toggle').on('click', function () {
                equalHeight($('#commercial-real-estate .grid-view-container .grid-list-item-inner-container .border-container'));

                $('.map-and-list-view-container').addClass('hidden');
                $('.grid-view-container').removeClass('hidden');

                $('.grid-view-toggle').addClass('hiding');
                setTimeout(function () { $('.grid-view-toggle').addClass('hidden'); }, 350);

                $('.list-view-toggle').removeClass('hidden');
                setTimeout(function () { $('.list-view-toggle').removeClass('hiding'); }, 100);

                setTimeout(function () {
                    $('.spacing-details').each(function () {
                        var subItems = $(this).find('.spacing-details-item'),
                            heightToSet = 0;

                        subItems.css('height', '');
                        subItems.each(function () {
                            if($(this).outerHeight() > heightToSet) {
                                heightToSet = $(this).outerHeight();
                            }
                        });
                        subItems.css('height', heightToSet);

                    });
                }, 1000);
            });

            $('.list-view-toggle').on('click', function () {
                $('.grid-view-container').addClass('hidden');
                $('.map-and-list-view-container').removeClass('hidden');

                $('.list-view-toggle').addClass('hiding');
                setTimeout(function () { $('.list-view-toggle').addClass('hidden'); }, 350);

                $('.grid-view-toggle').removeClass('hidden');
                setTimeout(function () { $('.grid-view-toggle').removeClass('hiding'); }, 100);
            });
        },

        initCommercialRealEstateListingMap: function () {

            var listingLatitude = parseFloat($('#commercial-real-estate-listing-latitude').val()),
                listingLongitude = parseFloat($('#commercial-real-estate-listing-longitude').val()),
                listingTitle = $('#commercial-real-estate-listing-title').val();

            var defaultMapOptions = {
                center: {
                    lat: listingLatitude,
                    lng: listingLongitude
                },
                zoom: 15,
                mapTypeControl: false,
                disableDefaultUI: false
            };

            function initMap() {
                console.log('should be here');

                var map = new google.maps.Map(document.getElementById('commercial-listing-map'), defaultMapOptions);
                var infoWindow = new google.maps.InfoWindow();

                map.setOptions({styles: defaultGoogleMapStyles});

                var marker = new google.maps.Marker({
                    position: {
                        lat: listingLatitude,
                        lng: listingLongitude
                    },
                    map: map,
                    title: listingTitle,
                    icon: '/assets/img/controls/icon-map-pin-green.svg'
                });

                // var content = '<div class="info-popup-container"><h4>' + listingTitle + '<h2>' +
                //     '<div class="map-info-contents" style="font-size: 12px;">blah</div></div>';
                //
                // google.maps.event.addListener(marker, 'click', (function(marker, content, infoWindow) {
                //     return function() {
                //         infoWindow.close();
                //         infoWindow.setContent(content);
                //         infoWindow.open(map, marker);
                //     }
                // })(marker, content, infoWindow));

                $('.map-zoom-trigger').on('click', function () {
                    $('#commercial-listing-map div.gm-style button[title="Toggle fullscreen view"]').trigger('click');
                });

                $('.satellite-view-trigger').on('click', function () {
                    map.setMapTypeId('satellite');
                    $(this).addClass('is-active');
                    $('.roadmap-view-trigger').removeClass('is-active');
                });

                $('.roadmap-view-trigger').on('click', function () {
                    map.setMapTypeId('roadmap');
                    $(this).addClass('is-active');
                    $('.satellite-view-trigger').removeClass('is-active');
                });
            }

            if($('#commercial-listing-map').length) {
                initMap();
            }

        },

        initCommercialRealEstateListingSlideshow: function () {

            if($('#commercial-listing-slideshow').length) {

                $('#commercial-listing-slideshow').slick({
                    infinite: false,
                    asNavFor: '#commercial-listing-slideshow-thumbnails',
                    prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/controls/prev-slide-arrow.svg" alt="Previous Project"></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/controls/next-slide-arrow.svg" alt="Next Project"></button>'
                });

                $('#commercial-listing-slideshow-thumbnails').slick({
                    infinite: false,
                    slidesToShow: 7,
                    slidesToScroll: 1,
                    asNavFor: '#commercial-listing-slideshow',
                    focusOnSelect: true,
                    prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/controls/prev-slide-arrow.svg" alt="Previous Project"></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/controls/next-slide-arrow.svg" alt="Next Project"></button>',
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 3
                            }
                        }
                    ]
                });

                $('.zoom-trigger').on('click', function () {
                    var target = $(this).data('target');
                    $(target).click();
                });
            }

        },

        initCommercialRealEstateListingForm: function () {

            $('#commercial-real-estate-listing-contact-form').validate({
                rules: {
                    first_name: "required",
                    last_name: "required",
                    email_address: {
                        required: true,
                        email: true
                    },
                    details: "required"
                },
                submitHandler: function(form) {
                    grecaptcha.execute();
                }
            });

        },

        initContactMaps: function () {

            function initMap(latitude, longitude, id, title) {
                var map = new google.maps.Map(document.getElementById(id), {
                    center: {
                        lat: latitude,
                        lng: longitude
                    },
                    zoom: 12,
                    mapTypeControl: false,
                    disableDefaultUI: true
                });

                map.setOptions({styles: defaultGoogleMapStyles});

                var marker = new google.maps.Marker({
                    position: {
                        lat: latitude,
                        lng: longitude
                    },
                    map: map,
                    title: title,
                    icon: '/assets/img/controls/icon-map-pin-green.svg'
                });
            }

            if($('.contact-map-item').length) {
                $('.contact-map-item').each(function () {
                    var mapObject = $(this).find('.contact-map-object');

                    var id = mapObject.data('element-id'),
                        lat = mapObject.data('latitude'),
                        lng = mapObject.data('longitude'),
                        title = mapObject.data('title');

                    initMap(lat, lng, id, title);
                });
            }
        },

        initContactPageControls: function () {

            function setMessageTextAreaSize() {
                var formFieldsLeft = $('#contact-form .form-fields-left'),
                    textAreaRight = $('#contact-message');

                textAreaRight.css('height', formFieldsLeft.outerHeight());
            }

            setMessageTextAreaSize();
            $(window).on('resize', function () { setMessageTextAreaSize(); });

            $('#contact-form-object').validate({
                rules: {
                    full_name: "required",
                    email_address: {
                        required: true,
                        email: true
                    },
                    // phone_number: "required",
                    message: "required"
                },
                submitHandler: function(form) {
                    grecaptcha.execute();
                }
            });

        },

        initResidentialTestimonialSlider: function () {
            $('.residential-testimonials-container').slick({
                slidesToShow: 2,
                dots: true,
                arrows: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        },

        initGeneralPage: function () {

            function blockquotePositioning() {
                var blockquotes = $('#page-content blockquote'),
                    outerWidth = $('.wrapper').outerWidth(),
                    pageContentWidth = $('#page-content').outerWidth(),
                    widthRatio = .6;

                if($(window).width() < 1200) { widthRatio = .7; }

                if($(window).width() > 768) {
                    blockquotes.each(function () {
                        $(this).css({
                            'margin-left': 0 - ((outerWidth - pageContentWidth) / 2),
                            'margin-right': 0 - ((outerWidth - pageContentWidth) / 2),
                            'width': outerWidth * widthRatio
                        });
                    });
                } else {
                    blockquotes.css({
                        'margin-left': '',
                        'margin-right': '',
                        'width': ''
                    });
                }
            }
            blockquotePositioning();
            $(window).on('resize', function () { blockquotePositioning(); });

        },

        initBlogControls: function () {
            equalHeight($('section#news-listings .news-list-item .details-container'), 600);

            $('section#news-categories .categories-label').on('click', function () {
                if($(window).width() < 992) {
                    $('section#news-categories .categories-list').slideToggle();
                }
            });

            if($('.social-share-container').length) {
                var shareContainer = $('.social-share-container'),
                    shareFromLeft = $('.social-share-container > a:first-of-type').offset().left,
                    shareFromTop = $('.social-share-container > a:first-of-type').offset().top;

                function checkSharePosition() {
                    var scrollTop = $(window).scrollTop();

                    if($(window).width() > 1200) {
                        if((shareFromTop - scrollTop) < 100) {
                            shareContainer.css({
                                'position': 'fixed',
                                'top': '101px',
                                'left': shareFromLeft
                            });
                        } else {
                            shareContainer.css({
                                'position': '',
                                'top': '',
                                'left': ''
                            });
                        }
                    } else {
                        shareContainer.css({
                            'position': '',
                            'top': '',
                            'left': ''
                        });
                    }
                }
                checkSharePosition();
                $(window).on('scroll', function () { checkSharePosition(); });
            }
        },

        initCareersControls: function () {

            equalHeight($('section#careers-news-block .news-list-item .details-container'), 600);

            if($('#main-image-left').length) {
                function positionLeftImage() {

                    if($(window).width() > 1200) {
                        var wrapperWidth = $('.wrapper').outerWidth(),
                            containerWidth = $('#careers .container').outerWidth();

                        $('#main-image-left').css('margin-left', 0 - ((wrapperWidth - containerWidth) / 2));
                    } else {
                        $('#main-image-left').css('margin-left', '');
                    }
                }

                positionLeftImage();
                $(window).on('resize', function () { positionLeftImage(); });
            }

        },

        initHospitalityControls: function () {

            equalHeight($('section#careers-news-block .news-list-item .details-container'), 600);

            // if($('#main-image-left').length) {
            //     function positionLeftImage() {
            //
            //         if($(window).width() > 1200) {
            //             var wrapperWidth = $('.wrapper').outerWidth(),
            //                 containerWidth = $('#hospitality-landing .container').outerWidth();
            //
            //             $('#main-image-left').css('margin-left', 0 - ((wrapperWidth - containerWidth) / 2));
            //         } else {
            //             $('#main-image-left').css('margin-left', '');
            //         }
            //     }
            //
            //     positionLeftImage();
            //     $(window).on('resize', function () { positionLeftImage(); });
            // }

        },

        initCaseStudyLandingControls: function () {

            $(".case-study-category-selector").on('click', function () {
                var target = $(this).data('target');

                $('.case-study-category-selector').not($(this)).removeClass('is-selected');
                $(this).addClass('is-selected');

                $('.case-study-category-container').not(target).addClass('is-hiding');

                setTimeout(function () {
                    $('.case-study-category-container').not(target).removeClass('is-active-case-study');
                    $(target).addClass('is-active-case-study');
                }, 300);

                setTimeout(function () {
                    $(target).removeClass('is-hiding');
                }, 600);

            });

        },

        initCaseStudySingleControls: function () {
            // HAS BEEN CONVERTED TO A BLOCK

            if($('#case-study-slideshow-object').length) {
                var caseStudySlideshow = $('#case-study-slideshow-object').slick({
                    infinite: false,
                    prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/controls/prev-slide-arrow.svg" alt="Previous Project"></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/controls/next-slide-arrow.svg" alt="Next Project"></button>'
                });

                caseStudySlideshow.on('afterChange', function(slick, currentSlide) {
                    $('#case-study-slideshow-count-indicator .slide-count').html(currentSlide.currentSlide + 1);
                });
            }

        },

        initFooterTestimonialsSlider: function () {
            // HAS BEEN CONVERTED TO A BLOCK

            let testimonialSlider = $('#testimonial-slider'),
                mobileArrowPrev = $('#testimonial-slider-mobile-arrows .slick-prev'),
                mobileArrowNext = $('#testimonial-slider-mobile-arrows .slick-next');

            testimonialSlider.slick({
                autoplay: true,
                fade: true,
                arrows: true,
                autoplaySpeed: testimonialSlider.data('slider-speed'),
                infinite: true,
                prevArrow: '<button type="button" class="desktop-only slick-prev"><img src="/assets/img/controls/prev-slide-arrow.svg" alt="Previous Project"></button>',
                nextArrow: '<button type="button" class="desktop-only slick-next"><img src="/assets/img/controls/next-slide-arrow.svg" alt="Next Project"></button>'
            });

            mobileArrowPrev.on('click', function () {
                testimonialSlider.slick('slickPrev');
            });

            mobileArrowNext.on('click', function () {
                testimonialSlider.slick('slickNext');
            });

        }

    }

};

var defaultGoogleMapStyles = [
    { elementType: 'geometry', stylers: [{color: '#f2f3f0'}] },
    { elementType: 'labels.icon', stylers: [{visibility: 'off'}] },
    { elementType: 'labels.text.fill', stylers: [{color: '#515c5f'}] },
    { elementType: 'labels.text.stroke', stylers: [{visibility: 'off'}] },
    { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{color: '#bdbdbd'}] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{color: '#f2f3f0'}] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{color: '#ffffff'}] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{color: '#f2f3f0'}] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{color: '#515c5f'}] },
    { featureType: 'road', elementType: 'geometry', stylers: [{color: '#ffffff'}] },
    { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{color: '#ffffff'}] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{color: '#ffffff'}] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{color: '#515c5f'}] },
    { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{color: '#515c5f'}] }, // Small Road Labels
    { featureType: 'transit.line', elementType: 'geometry', stylers: [{color: '#f2f3f0'}] },
    { featureType: 'transit.station', elementType: 'geometry', stylers: [{color: '#f2f3f0'}] },
    { featureType: 'water', elementType: 'geometry', stylers: [{color: '#c2c8ca'}] }, // Water Colors
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{color: '#000000'}] } // Water Labels
];

function equalHeight(items, cutoff) {

    function setHeight(items, cutoff) {
        $(window).imagesLoaded(function () {
            cutoff = typeof cutoff !== 'undefined' ? cutoff : false;
            var heightToSet = 0;

            items.css('height', '');

            if(!cutoff) {
                items.each(function () {
                    if($(this).outerHeight() > heightToSet) {
                        heightToSet = $(this).outerHeight();
                    }
                });

                items.css('height', heightToSet);
            } else {
                if($(window).width() > cutoff) {
                    items.each(function () {
                        if($(this).outerHeight() > heightToSet) {
                            heightToSet = $(this).outerHeight();
                        }
                    });

                    items.css('height', heightToSet);
                } else {
                    items.css('height', '');
                }
            }
        });
    }

    setHeight(items, cutoff);
    $(window).on('resize', function () { setHeight(items, cutoff); });

}

function includes(container, value) {
    var returnValue = false;
    var pos = container.indexOf(value);
    if (pos >= 0) {
        returnValue = true;
    }
    return returnValue;
}


var browser = function() {
    // Return cached result if avalible, else get result then cache it.
    if (browser.prototype._cachedResult)
        return browser.prototype._cachedResult;

    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]"
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1+
    var isChrome = !!window.chrome && !!window.chrome.webstore;

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    return browser.prototype._cachedResult =
        isOpera ? 'Opera' :
        isFirefox ? 'Firefox' :
        isSafari ? 'Safari' :
        isChrome ? 'Chrome' :
        isIE ? 'IE' :
        isEdge ? 'Edge' :
        isBlink ? 'Blink' :
        "Don't know";
};

UTIL = {

    fire : function(func, funcname, args){

        var namespace = APP;

        funcname = (funcname === undefined) ? 'init' : funcname;
        if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
            namespace[func][funcname](args);
        }

    },

    loadEvents : function($){

        var bodyId = document.body.id;

        // hit up common first.
        UTIL.fire('global');

        // do all the classes too.
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
            UTIL.fire(classnm);
            UTIL.fire(classnm,bodyId);
        });

    }
};

(function($) {
    // kick it all off here
    UTIL.loadEvents($);
})( jQuery );
